// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"3cd17682","170":"3cd17682"}[chunkId] + ".chunk.css";
};